import React, { useContext } from 'react'
import { Route, Routes } from 'react-router-dom'

import NotFound from '../NotFound'

import { AbilityContext } from '../../components/Ability'
import CategoriesListPage from './Features/CategoriesList'


const CategoriesPage = () => {
  const ability = useContext(AbilityContext)

  return (
    <Routes>
      <Route
        path="/"
        element={
          ability.can('manage', 'Product', 'category') ? < CategoriesListPage /> : <NotFound />
        }
      />
    </Routes>
  )
}

export default CategoriesPage
